import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

@Injectable()
export class VulnerabilityInfoService {
  constructor (private http: Http) {
  }
}
